import { validateTidalLicense } from "../../base/index.js";
import { WHITE_SPACES } from "./utils/constants.js";
function trimLeft(source, chars = WHITE_SPACES) {
  const len = source.length;
  const charLen = chars.length;
  let start = 0;
  let found = true;
  let i;
  let c;
  while (found && start < len) {
    found = false;
    i = -1;
    c = source.charAt(start);
    while (++i < charLen) {
      if (c === chars[i]) {
        found = true;
        start++;
        break;
      }
    }
  }
  return start >= len ? "" : source.substr(start, len);
}
validateTidalLicense();
export {
  trimLeft
};
//# sourceMappingURL=trimLeft.js.map
